export default __webpack_public_path__ + "static/media/Alone.1b684d72.mp3";